(ns minorodata.components.markdown.core
  (:require
   ["copy-to-clipboard" :as copy]
   ["lucide-react" :refer [Clipboard]]
   ["react-markdown" :default react-markdown]
   ["rehype-unwrap-images" :default rehype-unwrap-images]
   ["rehype-external-links" :default rehype-external-links]
   ["remark-breaks" :default remark-breaks]
   ["remark-emoji" :default remark-emoji]
   ["remark-gfm" :default remark-gfm]
   ["remark-images" :default remark-images]
   [applied-science.js-interop :as js-interop]
   [react :as react]
   [reagent.core :as reagent]))


(defn fancy-code-preview [{:keys [className children]}]
  (let [code-ref (react/useRef nil)
        sql-statement (js/String. children)]

    (react/useEffect
     (fn []
       (when-let [node (js-interop/get code-ref :current)]
         (let [hljs  (js-interop/get js/window :hljs)]
           (when hljs
             (js-interop/call hljs :highlightElement node))))
       (fn []))
     #js [code-ref])


    [:div {:class "w-full overflow-hidden flex flex-col m-0 rounded-lg  border-kleene-neutral-03  dark:border-kleene-dark-03 border"}
     [:div {:class "bg-kleene-neutral-05 dark:bg-kleene-dark-02 border-b py-1 px-2 flex items-center"}
      [:span {:class "grow text-kleene-text "} "sql"]
      [:button {:class "mx-3 hover:opacity-80 active:opacity-50 text-kleene-text "
                :on-click #(copy sql-statement #js {:format "text/plain"})}
       [:> Clipboard {:size 14
                      :class "mb-[-2px] mr-1"}]]]
     [:div {:class "overflow-x-scroll"}
      (into [:code {:class [className "postgres"]
                    :ref code-ref}]
            children)]]))

(defn formatted-text [{:keys [text]}]
  [:> react-markdown
   {:children text
    :components #js {:code (fn [props]
                             (let [{:keys [children className]} (js-interop/lookup props)
                                   snippet? (some? (re-find #"language-" (or className "")))]
                               (reagent/as-element
                                (if snippet?
                                  [:f> fancy-code-preview {:className className :children children}]
                                  (into [:code {:class [className]
                                                :data-snippet snippet?}]
                                        children)))))}
    :remarkPlugins
    [remark-gfm
     remark-emoji
     remark-breaks
     remark-images]

    :rehypePlugins
    [rehype-unwrap-images
     [rehype-external-links, #js {:target "_blank"}]]}])
